import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { GlobalEventMangerService } from '../global-event-manger.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-menuitems',
  templateUrl: './menuitems.component.html',
  styleUrls: ['./menuitems.component.css']
})
export class MenuitemsComponent implements OnInit {

  public menueChexSuAdmin :{};
  public menueChexAdmin :{};
  public menueChexMerchant :{};
  public menueChexMerchantUser :{};
  public userRole : string;
  public userFirstName : string;
  public userLastName : string;
  public backToAdmin : string;
  public showNavBar : boolean=false;
  public menuPermissionVal :{};
  public ghostLogin : boolean=false;
  public ProfileImage : string;
  public merchantImg_url: string;
  public href: string = "";

  constructor(private globalEventMangerService: GlobalEventMangerService, private route: ActivatedRoute, private router: Router, private localStorageService: LocalstorageService, protected userService:UserService) {
		this.globalEventMangerService.showNavBarEmitter.subscribe((mode)=>{
			// mode will be null the first time it is created, so you need to igonore it when null
			
			if (this.localStorageService.getData("currentUser")) {
				mode = true;
				let userDetails = <any>{};
				let menuPermission = <any>{};
				let Profile_image = <any>{};
				let Business_image = <any>{};
				userDetails = this.localStorageService.getData("currentUser");
				menuPermission = userDetails.settings;
				this.menuPermissionVal = menuPermission.permissions;
				this.userRole = userDetails.role_id;
				this.userFirstName = userDetails.first_name;
				this.userLastName = userDetails.last_name;

				Profile_image = this.localStorageService.getData("Profile_image");

				Business_image = this.localStorageService.getData("Mer_Profile_image");
				this.merchantImg_url = Business_image ? Business_image.business_image_url : (userDetails && userDetails.business_image_url);
				if (userDetails) {
					this.userFirstName = userDetails.first_name;
					this.userLastName = userDetails.last_name;
					this.ProfileImage =  Profile_image ? Profile_image : userDetails.image_url;
				}
				
			}

			if (mode !== null) {
			  this.showNavBar = mode;
			}
			if(this.showNavBar == true && this.userRole == '1'){
				// eChex Su Admin Menu
				this.menueChexSuAdmin = [
					{
						title: "Dashboard",
						url: "dashboard",
						class: "fa fa-home fa-lg",
					},
					// {
					// 	title: "CasherPay Admin",
					// 	url: "echex-admin",
					// 	class: "fa fa-user-md fa-lg",
					// },
					{
						title: "Transactions",
						url: "transactions",
						class: "fa fa-credit-card fa-lg"
					},
					{
						title: "Profile",
						url: "profile",
						class: "fa fa-user fa-lg"
					},
					{
						title: "Plan",
						url: "plan",
						class: "fa fa-user fa-lg"
					},

					{
						title: "Email Template",
						url: "email-templates",
						class: "fa fa-user fa-lg"
					},
					{
						title: "CasherPay Merchant",
						url: "echex-merchant",
						class: "fa fa-user fa-lg"
					},
					{
						title: "CasherPay Merchant Users",
						url: "casherpay-users",
						class: "fa fa-user fa-lg"
					},
					{
						title: "Permission",
						url: "permisions",
						class: "fa fa-external-link fa-lg"
					},
					{
						title: "Status",
						url: "status",
						class: "fa fa-link fa-lg"
					},
					{
							title: "Activity Log",
							url: "activity-logs",
							class: "fa fa-link fa-lg"
					},
					{
							title: "Invoice",
							url: "invoice",
							class: "fa fa-link fa-lg"
					},
				]

				this.href = this.router.url;
				let url = this.router.url;
				let repStr = this.href.replace('/','')
				let urlStr = repStr.split("/")[0];

				let sup_adm_url_exist = 0;

				for(let o in this.menueChexSuAdmin){
					let child = this.menueChexSuAdmin[o];
					if(child.url === urlStr) {
						sup_adm_url_exist = 1;
					}
				}

				let other_url = ['edit-permission', 'add-echex-admin', 'echex-permisions','add-plan', 'view-invoice','permision-add','create-status','edit-status','create-template','edit-template','create-plan','edit-plan','edit-transaction','add-echex-merchant','edit-echex-merchant','casherpay-merchant-user-permision', 'edit-echex-merchant-user'];
				let oth_url_exist = other_url.includes(urlStr);

				if(oth_url_exist) {
					sup_adm_url_exist = 1;
				}

				if(sup_adm_url_exist === 0 && urlStr) {
					if (url=== "/get-started-deposits" || url ==="/get-started-plan" || url=== "/thank-you" || url=== "/" || url=== "/bank/auth" || url=== "/secure/url" || url==='/register' || url==='/login' || url ==='/set-password' || url ==='/reset' || url ==='/forgot' || url ==='/account/verify' || url ==='/getting-started' || url ==='/page-not-found' ) {
						// this.globalEventMangerService.showNavBar(false);
						// this.showNavBar = false;
					} else if ((window.location.href.indexOf("/print/send/cheque") > -1) || (window.location.href.indexOf("/printed/send/cheque") > -1) || (window.location.href.indexOf("/bank/auth") > -1) || (window.location.href.indexOf("/secure/url") > -1) || (window.location.href.indexOf("/account/verify") > -1) || (window.location.href.indexOf("/thank-you-url") > -1 || (window.location.href.indexOf("/reset") > -1)|| (window.location.href.indexOf("/register") > -1) || (window.location.href.indexOf("/set-password") > -1) || (window.location.href.indexOf("/pay-invoice") > -1) || (window.location.href.indexOf("/invoice/bank/auth") > -1) || (window.location.href.indexOf("/invoice/secure/url") > -1))) {
						// this.globalEventMangerService.showNavBar(false); 
						// this.showNavBar = false;
					} else {
						this.router.navigate(['/page-not-found']);	
					}	
				}
			}
			if(this.showNavBar == true && this.userRole == '2'){
					// eChex Admin Menu
					this.menueChexAdmin = [
					{
						title: "Dashboard",
						url: "dashboard",
						value: this.menuPermissionVal['Dashboard'],
						class: "fa fa-home fa-lg"
					},
					 {
						title: "Transactions",
						url: "transactions",
						value: this.menuPermissionVal['Transactions'],
						class: "fa fa-credit-card fa-lg"
					},
					 {
						title: "Profile",
						url: "profile",
						value: this.menuPermissionVal['Profile'],
					   class: "fa fa-user fa-lg"
					},
					{
						title: "Plan",
						url: "plan",
						value: this.menuPermissionVal['Plan'],
						class: "fa fa-user fa-lg"
					},
					{
						title: "Email Template",
						url: "email-templates",
						value: this.menuPermissionVal['Email Template'],
						class: "fa fa-user fa-lg"
					},
					{
						title: "CasherPay Merchant",
						url: "echex-merchant",
						class: "fa fa-user fa-lg"
					},
					{
						title: "CasherPay Merchant Users",
						url: "casherpay-users",
						class: "fa fa-user fa-lg"
					},
					{
						title: "Permission",
						url: "permisions",
						value: this.menuPermissionVal['Permision'],
						class: "fa fa-external-link fa-lg"
					},
					
					 {
						title: "Status",
						url: "status",
						value: this.menuPermissionVal['Status'],
						class: "fa fa-link fa-lg"
					},
					{
						title: "Activity Log",
						url: "activity-logs",
						class: "fa fa-link fa-lg"
					},
					
				]

				this.href = this.router.url;
				let url = this.router.url;
				let repStr = this.href.replace('/','')
				let urlStr = repStr.split("/")[0];
				let adm_url_exist = 0;

				for(let o in this.menueChexAdmin){
					let child = this.menueChexAdmin[o];
					if(child.url === urlStr) {
						adm_url_exist = 1;
					}
				}

				let other_url = ['edit-permission', 'add-echex-admin', 'echex-permisions','add-plan', 'view-invoice','permision-add','create-status','edit-status','create-template','edit-template','create-plan','edit-plan','edit-transaction','add-echex-merchant','edit-echex-merchant','casherpay-merchant-user-permision', 'edit-echex-merchant-user'];
				let oth_url_exist = other_url.includes(urlStr);

				if(oth_url_exist) {
					adm_url_exist = 1;
				}

				if(adm_url_exist === 0 && urlStr) {
					if (url=== "/get-started-deposits" || url ==="/get-started-plan" || url=== "/thank-you" || url=== "/" || url=== "/bank/auth" || url=== "/secure/url" || url==='/register' || url==='/login' || url ==='/set-password' || url ==='/reset' || url ==='/forgot' || url ==='/account/verify' || url ==='/getting-started' || url ==='/page-not-found' ) {
						// this.globalEventMangerService.showNavBar(false);
						// this.showNavBar = false;
					} else if ((window.location.href.indexOf("/print/send/cheque") > -1) || (window.location.href.indexOf("/printed/send/cheque") > -1) || (window.location.href.indexOf("/bank/auth") > -1) || (window.location.href.indexOf("/secure/url") > -1) || (window.location.href.indexOf("/account/verify") > -1) || (window.location.href.indexOf("/thank-you-url") > -1 || (window.location.href.indexOf("/reset") > -1)|| (window.location.href.indexOf("/register") > -1) || (window.location.href.indexOf("/set-password") > -1) || (window.location.href.indexOf("/pay-invoice") > -1) || (window.location.href.indexOf("/invoice/bank/auth") > -1) || (window.location.href.indexOf("/invoice/secure/url") > -1))) {
						// this.globalEventMangerService.showNavBar(false); 
						// this.showNavBar = false;
					} else {
						this.router.navigate(['/page-not-found']);	
					}
				}
			}
			if((this.showNavBar == true && this.userRole == '3')){
				// eChex Merchant Menu
				this.menueChexMerchant = [
					{
						title: "Dashboard",
						url: "dashboard",
						value: this.menuPermissionVal['Dashboard'],
						class: "fa fa-home fa-lg"
					},
					 {
						title: "Transactions",
						url: "transactions",
						value: this.menuPermissionVal['Transactions'],
						class: "fa fa-credit-card fa-lg"
					},
					 {
						title: "Account",
						url: "account",
						value: this.menuPermissionVal['Account'],
						class: "fa fa-exchange fa-lg"
					},
					 {
						title: "Profile",
						url: "profile",
						value: this.menuPermissionVal['Profile'],
					   class: "fa fa-user fa-lg"
					},
					
					{
						title: "Create Bank Auth Url Link",
						url: "create-bank-auth-url-link",
						value: this.menuPermissionVal['CreateBankAuthUrllink'],
						class: "fa fa-link fa-lg"
					},
					{
						title: "Create Secure Url Link",
						url: "create-secure-url-link",
						value: this.menuPermissionVal['CreateSecureUrlLink'],
						class: "fa fa-shield fa-lg"
					},
					 {
						title: "Send Check",
						url: "sendcheck",
						value: this.menuPermissionVal['SendCheck'],
						class: "fa fa-share-square-o fa-lg"
					},
					
					{
						title: "Create Check",
						url: "create-cheque",
						value: this.menuPermissionVal['CreateCheque'],
						class: "fa fa-bank fa-lg"
					},
					{
						title: "Create Invoice",
						url: "create-invoice",
						value: this.menuPermissionVal['Invoice'],
						class: "fa fa-file-pdf-o fa-lg"
					}
				]

				this.href = this.router.url;
				let url = this.router.url;
				let repStr = this.href.replace('/','')
				let urlStr = repStr.split("/")[0];
				let mer_url_exist = 0;

				for(let o in this.menueChexMerchant){
					let child = this.menueChexMerchant[o];
					if(child.url === urlStr) {
						mer_url_exist = 1;
					}
				}

				let other_url = ['view-invoice','edit-transaction','casherpay-merchant-user-permision'];
				let oth_url_exist = other_url.includes(urlStr);

				if(oth_url_exist) {
					mer_url_exist = 1;
				}

				if(mer_url_exist === 0 && urlStr) {
					if (url=== "/get-started-deposits" || url ==="/get-started-plan" || url=== "/thank-you" || url=== "/" || url=== "/bank/auth" || url=== "/secure/url" || url==='/register' || url==='/login' || url ==='/set-password' || url ==='/reset' || url ==='/forgot' || url ==='/account/verify' || url ==='/getting-started' || url ==='/page-not-found' ) {
						// this.globalEventMangerService.showNavBar(false);
						// this.showNavBar = false;
					} else if ((window.location.href.indexOf("/print/send/cheque") > -1) || (window.location.href.indexOf("/printed/send/cheque") > -1) || (window.location.href.indexOf("/bank/auth") > -1) || (window.location.href.indexOf("/secure/url") > -1) || (window.location.href.indexOf("/account/verify") > -1) || (window.location.href.indexOf("/thank-you-url") > -1 || (window.location.href.indexOf("/reset") > -1)|| (window.location.href.indexOf("/register") > -1) || (window.location.href.indexOf("/set-password") > -1) || (window.location.href.indexOf("/pay-invoice") > -1) || (window.location.href.indexOf("/invoice/bank/auth") > -1) || (window.location.href.indexOf("/invoice/secure/url") > -1))) {
						// this.globalEventMangerService.showNavBar(false); 
						// this.showNavBar = false;
					} else {
						this.router.navigate(['/page-not-found']);	
					}
				}
			}

			if((this.showNavBar == true && this.userRole == '4') ){
				// eChex Merchant Menu
				this.menueChexMerchantUser = [
					{
						title: "Dashboard",
						url: "dashboard",
						value: this.menuPermissionVal['Dashboard'],
						class: "fa fa-home fa-lg"
					},
					{
						title: "Profile",
						url: "profile",
						value: this.menuPermissionVal['Profile'],
					   class: "fa fa-user fa-lg"
					},
					{
						title: "Transactions",
						url: "transactions",
						value: this.menuPermissionVal['Transactions'],
						class: "fa fa-credit-card fa-lg"
					},
					{
						title: "Create Check",
						url: "create-cheque",
						value: this.menuPermissionVal['CreateCheque'],
						class: "fa fa-bank fa-lg"
					},
					{
						title: "Create Invoice",
						url: "create-invoice",
						value: this.menuPermissionVal['Invoice'],
						class: "fa fa-file-pdf-o fa-lg"
					}
				]

				this.href = this.router.url;
				let url = this.router.url;
				let repStr = this.href.replace('/','')
				let urlStr = repStr.split("/")[0];
				let mer_url_exist = 0;

				for(let o in this.menueChexMerchantUser){
					let child = this.menueChexMerchantUser[o];
					if(child.url === urlStr) {
						mer_url_exist = 1;
					}
				}

				let other_url = ['edit-transaction'];
				let oth_url_exist = other_url.includes(urlStr);

				if(oth_url_exist) {
					mer_url_exist = 1;
				}

				if(mer_url_exist === 0 && urlStr) {
					if (url=== "/get-started-deposits" || url ==="/get-started-plan" || url=== "/thank-you" || url=== "/" || url=== "/bank/auth" || url=== "/secure/url" || url==='/register' || url==='/login' || url ==='/set-password' || url ==='/reset' || url ==='/forgot' || url ==='/account/verify' || url ==='/getting-started' || url ==='/page-not-found' ) {
						// this.globalEventMangerService.showNavBar(false);
						// this.showNavBar = false;
					} else if ((window.location.href.indexOf("/print/send/cheque") > -1) || (window.location.href.indexOf("/printed/send/cheque") > -1) || (window.location.href.indexOf("/bank/auth") > -1) || (window.location.href.indexOf("/secure/url") > -1) || (window.location.href.indexOf("/account/verify") > -1) || (window.location.href.indexOf("/thank-you-url") > -1 || (window.location.href.indexOf("/reset") > -1)|| (window.location.href.indexOf("/register") > -1) || (window.location.href.indexOf("/set-password") > -1) || (window.location.href.indexOf("/pay-invoice") > -1) || (window.location.href.indexOf("/invoice/bank/auth") > -1) || (window.location.href.indexOf("/invoice/secure/url") > -1))) {
						// this.globalEventMangerService.showNavBar(false); 
						// this.showNavBar = false;
					} else {
						this.router.navigate(['/page-not-found']);	
					}
				}
			}
		});  
		//ghost login
        this.globalEventMangerService.ghostLoginEmitter.subscribe((mode)=>{
        	if (this.localStorageService.getData("currentUser")) {
				mode = true;
				this.backToAdmin = this.localStorageService.getData("merchantAdmin");
				
			}
		
           if (mode !== null) {
              this.ghostLogin = mode;
            }
        });
		
		 this.router.events.subscribe(event => {
		  if (event instanceof NavigationEnd ) {
			this.modifyHeader(event);
		  }
		});
       
	}
	
	ngOnInit() {
		this.localStorageService.dataUpdated.subscribe(() => {
			let userDetails = <any>{};
			let menuPermission = <any>{};
			let Profile_image = <any>{};
			let Businessimage = <any>{};
			userDetails = this.localStorageService.getData("currentUser");
			Profile_image = this.localStorageService.getData("Profile_image")
			if (userDetails) {
				this.userFirstName = userDetails.first_name;
				this.userLastName = userDetails.last_name;
				this.ProfileImage =  Profile_image ? Profile_image.image_url : userDetails.image_url;
			}

			if (userDetails) {
				this.userFirstName = userDetails.first_name;
				this.userLastName = userDetails.last_name;
				this.ProfileImage =  Profile_image ? Profile_image : userDetails.image_url;
			}
			Businessimage = this.localStorageService.getData("Mer_Profile_image");
			if (Businessimage) {
				this.merchantImg_url = Businessimage ? Businessimage.business_image_url : (userDetails && userDetails.business_image_url);
			} else{
				if (userDetails) {
					this.merchantImg_url = (userDetails && userDetails.business_image_url);
				}
			}
		});
	}
	
	// Show or hide the users header or side bar
	modifyHeader(location) {
		 if(location.url){
			var url = location.url;
			if (url=== "/get-started-deposits" || url ==="/get-started-plan" || url=== "/thank-you" || url=== "/" || url=== "/bank/auth" || url=== "/secure/url" || url==='/register' || url==='/login' || url ==='/set-password' || url ==='/reset' || url ==='/forgot' || url ==='/account/verify' || url ==='/getting-started' || url ==='/page-not-found' ) {
				this.globalEventMangerService.showNavBar(false);
				this.showNavBar = false;
			} else if ((window.location.href.indexOf("/print/send/cheque") > -1) || (window.location.href.indexOf("/printed/send/cheque") > -1) || (window.location.href.indexOf("/bank/auth") > -1) || (window.location.href.indexOf("/secure/url") > -1) || (window.location.href.indexOf("/account/verify") > -1) || (window.location.href.indexOf("/thank-you-url") > -1 || (window.location.href.indexOf("/reset") > -1)|| (window.location.href.indexOf("/register") > -1) || (window.location.href.indexOf("/set-password") > -1) || (window.location.href.indexOf("/pay-invoice") > -1) || (window.location.href.indexOf("/invoice/bank/auth") > -1) || (window.location.href.indexOf("/invoice/secure/url") > -1))) {
				this.globalEventMangerService.showNavBar(false); 
				this.showNavBar = false;
			} else {
			    this.globalEventMangerService.showNavBar(true);
			}
		 }
	}
	


	// Back to admin after ghost login
	backTOAdmin(){
		// Remove ghost login local storage details
		this.localStorageService.removeData('currentUser');
		this.localStorageService.removeData('currentUserToken');
		this.localStorageService.removeData('merchantAdmin');
		
		// get super admin token from storage and store in local storage
		let data = this.localStorageService.getData("super_admin_token");
		
		this.localStorageService.setData("currentUserToken", data);
		// get super admin details
		let super_admin_details = this.localStorageService.getData("super_admin_detail");
		this.localStorageService.setData("currentUser", super_admin_details);
		
		let userDetails = this.localStorageService.getData("currentUser");
		this.globalEventMangerService.showNavBar(true);
		this.globalEventMangerService.ghostLogin(false);
		if(userDetails.role_id == '1'){
		 this.router.navigate(['/dashboard']);
		}
		this.localStorageService.removeData("Mer_Profile_image");
		this.localStorageService.removeData("Profile_image");
	}

	// Logout link
	logOut(){
		let currentUser = this.localStorageService.getData("currentUserToken");
        let token =  currentUser.data.user_token;
		this.userService.userLogout(token).subscribe(
			response => {
				console.log('User logout successfully');
			}
		);
		this.localStorageService.removeData('currentUserToken');
		this.localStorageService.removeData('currentUser');
		this.localStorageService.removeData('super_admin_detail');
		this.localStorageService.removeData('super_admin_token');
		this.localStorageService.removeData("Profile_image");
		this.localStorageService.removeData('Mer_Profile_image');
		this.globalEventMangerService.ghostLogin(false);
		this.localStorageService.removeData('merchantAdmin');
		let merchantAdmin = this.localStorageService.getData("merchantAdmin");
		this.backToAdmin ="";
		this.globalEventMangerService.showNavBar(false);
		this.router.navigate(['/login']);
	}

	

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/menuitems/menuitems.component.ts